import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

export const DROPDOWN_STYLE = {
  BOX: 0,
  UNDERLINE: 1,
};

export type NavigationStylesParams = {
  // Navigation container
  navigationContainerBackgroundColor: StyleParamType.Color;
  navigationContainerPaddingHorizontal: StyleParamType.Number;
  navigationContainerPaddingVertical: StyleParamType.Number;
  navigationScrollArrowColor: StyleParamType.Color;
  navigationDividerColor: StyleParamType.Color;
  navigationContainerBorderTopColor: StyleParamType.Color;
  navigationContainerBorderTopWidth: StyleParamType.Number;
  navigationContainerBorderRightColor: StyleParamType.Color;
  navigationContainerBorderRightWidth: StyleParamType.Number;
  navigationContainerBorderBottomColor: StyleParamType.Color;
  navigationContainerBorderBottomWidth: StyleParamType.Number;
  navigationContainerBorderLeftColor: StyleParamType.Color;
  navigationContainerBorderLeftWidth: StyleParamType.Number;
  navigationContainerBorderLinked: StyleParamType.Number;
  navigationContainerCornerRadiusTopLeft: StyleParamType.Number;
  navigationContainerCornerRadiusTopRight: StyleParamType.Number;
  navigationContainerCornerRadiusBottomLeft: StyleParamType.Number;
  navigationContainerCornerRadiusBottomRight: StyleParamType.Number;
  navigationContainerCornerRadiusLinked: StyleParamType.Number;

  // Multi menu dropdown
  multiMenuDropdownStyle: StyleParamType.Number;
  // 1 = BOX, 0 = UNDERLINE. Navigation.st.css multiplies side border widths by this value.
  multiMenuDropdownIsBox: StyleParamType.Number;
  multiMenuDropdownFont: StyleParamType.Font;
  multiMenuDropdownTextColor: StyleParamType.Color;
  multiMenuDropdownBackgroundColor: StyleParamType.Color;
  multiMenuDropdownBorderColor: StyleParamType.Color;
  multiMenuDropdownBorderWidth: StyleParamType.Number;
  multiMenuDropdownCornerRadius: StyleParamType.Number;

  // Section navigation tabs - Default
  navTabDefaultFont: StyleParamType.Font;
  navTabDefaultTextColor: StyleParamType.Color;
  navTabDefaultBackgroundColor: StyleParamType.Color;
  navTabDefaultBorderTopColor: StyleParamType.Color;
  navTabDefaultBorderTopWidth: StyleParamType.Number;
  navTabDefaultBorderLinked: StyleParamType.Number;
  navTabDefaultBorderRightColor: StyleParamType.Color;
  navTabDefaultBorderRightWidth: StyleParamType.Number;
  navTabDefaultBorderBottomColor: StyleParamType.Color;
  navTabDefaultBorderBottomWidth: StyleParamType.Number;
  navTabDefaultBorderLeftColor: StyleParamType.Color;
  navTabDefaultBorderLeftWidth: StyleParamType.Number;
  navTabDefaultCornerRadiusTopLeft: StyleParamType.Number;
  navTabDefaultCornerRadiusTopRight: StyleParamType.Number;
  navTabDefaultCornerRadiusBottomLeft: StyleParamType.Number;
  navTabDefaultCornerRadiusBottomRight: StyleParamType.Number;
  navTabDefaultCornerRadiusLinked: StyleParamType.Number;

  // Section navigation tabs - Selected
  navTabSelectedFont: StyleParamType.Font;
  navTabSelectedTextColor: StyleParamType.Color;
  navTabSelectedBackgroundColor: StyleParamType.Color;
  navTabSelectedBorderTopColor: StyleParamType.Color;
  navTabSelectedBorderTopWidth: StyleParamType.Number;
  navTabSelectedBorderLinked: StyleParamType.Number;
  navTabSelectedBorderRightColor: StyleParamType.Color;
  navTabSelectedBorderRightWidth: StyleParamType.Number;
  navTabSelectedBorderBottomColor: StyleParamType.Color;
  navTabSelectedBorderBottomWidth: StyleParamType.Number;
  navTabSelectedBorderLeftColor: StyleParamType.Color;
  navTabSelectedBorderLeftWidth: StyleParamType.Number;
  navTabSelectedCornerRadiusTopLeft: StyleParamType.Number;
  navTabSelectedCornerRadiusTopRight: StyleParamType.Number;
  navTabSelectedCornerRadiusBottomLeft: StyleParamType.Number;
  navTabSelectedCornerRadiusBottomRight: StyleParamType.Number;
  navTabSelectedCornerRadiusLinked: StyleParamType.Number;
};

export const navigationStylesParams =
  createStylesParams<NavigationStylesParams>({
    // Navigation container
    navigationContainerBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-1', 1),
    },
    navigationContainerPaddingHorizontal: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navigationContainerPaddingVertical: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navigationScrollArrowColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navigationDividerColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navigationContainerBorderTopColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navigationContainerBorderTopWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navigationContainerBorderRightColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navigationContainerBorderRightWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navigationContainerBorderBottomColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navigationContainerBorderBottomWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navigationContainerBorderLeftColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navigationContainerBorderLeftWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navigationContainerBorderLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
    navigationContainerCornerRadiusTopLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navigationContainerCornerRadiusTopRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navigationContainerCornerRadiusBottomLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navigationContainerCornerRadiusBottomRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navigationContainerCornerRadiusLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },

    // Multi menu dropdown
    multiMenuDropdownStyle: {
      type: StyleParamType.Number,
      getDefaultValue: () => DROPDOWN_STYLE.BOX,
    },
    multiMenuDropdownIsBox: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
    multiMenuDropdownFont: {
      type: StyleParamType.Font,
      getDefaultValue: (params) =>
        wixFontParam('Body-M', {
          htmlTag: 'p',
          size: params.isMobile ? 14 : 16,
        })(params),
    },
    multiMenuDropdownTextColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    multiMenuDropdownBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-1', 1),
    },
    multiMenuDropdownBorderColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    multiMenuDropdownBorderWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
    multiMenuDropdownCornerRadius: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },

    // Section navigation tabs - Default
    navTabDefaultFont: {
      type: StyleParamType.Font,
      getDefaultValue: (params) =>
        wixFontParam('Body-M', {
          htmlTag: 'p',
          size: params.isMobile ? 14 : 16,
        })(params),
    },
    navTabDefaultTextColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navTabDefaultBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-1', 1),
    },
    navTabDefaultBorderTopColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navTabDefaultBorderTopWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabDefaultBorderLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
    navTabDefaultBorderRightColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navTabDefaultBorderRightWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabDefaultBorderBottomColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navTabDefaultBorderBottomWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabDefaultBorderLeftColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navTabDefaultBorderLeftWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabDefaultCornerRadiusTopLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabDefaultCornerRadiusTopRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabDefaultCornerRadiusBottomLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabDefaultCornerRadiusBottomRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabDefaultCornerRadiusLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },

    // Section navigation tabs - Selected
    navTabSelectedFont: {
      type: StyleParamType.Font,
      getDefaultValue: (params) =>
        wixFontParam('Body-M', {
          htmlTag: 'p',
          size: params.isMobile ? 14 : 16,
        })(params),
    },
    navTabSelectedTextColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navTabSelectedBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-1', 1),
    },
    navTabSelectedBorderTopColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navTabSelectedBorderTopWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabSelectedBorderLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabSelectedBorderRightColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navTabSelectedBorderRightWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabSelectedBorderBottomColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8', 1),
    },
    navTabSelectedBorderBottomWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 2,
    },
    navTabSelectedBorderLeftColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    navTabSelectedBorderLeftWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabSelectedCornerRadiusTopLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabSelectedCornerRadiusTopRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabSelectedCornerRadiusBottomLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabSelectedCornerRadiusBottomRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    navTabSelectedCornerRadiusLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
  });
